/**
 * Calculates the appropriate price for an activity based on:
 * - Free flag and base fee
 * - Available packages (uses minimum non-zero package fee when present)
 * @param activity The activity object
 * @returns The calculated price (number)
 */
export const calculateActivityFee = (activity: {
  free: boolean;
  fee: number;
  packages: Array<{ fee: number }>;
  currency: string;
}): number => {
  // Return 0 if explicitly free with no chargeable packages
  if (
    activity?.free &&
    activity?.fee === 0 &&
    !activity.packages?.some((pkg) => pkg.fee > 0)
  ) {
    return 0;
  }

  // Use minimum non-zero package fee if packages exist
  if (activity?.packages?.length > 0) {
    const validPackages = activity.packages.filter((pkg) => pkg.fee > 0);
    if (validPackages.length > 0) {
      return Math.min(...validPackages.map((pkg) => pkg.fee));
    }
  }

  // Default to activity fee (or 0 if undefined)
  return activity?.fee || 0;
};
